import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core'
import {
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms'
import {Observable, of, Subject} from 'rxjs'
import {filter, map, takeUntil, tap} from 'rxjs/operators'
import {filterTypeValue} from '../search-filter.component'

export type RangeFilterTypes =
  | filterTypeValue.BEFORE
  | filterTypeValue.AFTER
  | filterTypeValue.BETWEEN_TIMESTAMPS
  | filterTypeValue.LESS_THAN
  | filterTypeValue.GREATER_THAN
  | filterTypeValue.BETWEEN_VALUES

@Component({
  selector: 'mypayter-portal-range-filter',
  templateUrl: './range-filter.component.html',
  styleUrls: ['./range-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RangeFilterComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class RangeFilterComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  @Input() rangeType$: Observable<RangeFilterTypes> = of(filterTypeValue.AFTER)
  form: FormGroup
  activeFields$: Observable<string[]>
  destroy$ = new Subject<void>()

  constructor(private fb: FormBuilder) {}
  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  writeValue(obj: any): void {
    if (obj) {
      this.form.patchValue(obj, {emitEvent: false})
    } else {
      this.form.setValue(
        {
          begin: null,
          end: null,
          min: null,
          max: null,
        },
        {emitEvent: false},
      )
    }
  }
  registerOnChange(fn: any): void {
    this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(fn)
  }
  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error('Method not implemented.');
  }

  ngOnInit() {
    this.form = this.fb.group({
      begin: this.fb.control(null),
      end: this.fb.control(null),
      min: this.fb.control(null),
      max: this.fb.control(null),
    })
    this.activeFields$ = this.rangeType$.pipe(
      filter((r) => !!r),
      map((r) => this.pluckFields(r)),
      tap((fields) => {
        const toPatch = {}
        ;['begin', 'end', 'min', 'max'].forEach((item) => {
          if (!fields.includes(item)) {
            toPatch[item] = null
          }
        })
        // setTimeout needed to trigger validation on Init
        setTimeout(() => {
          this.form.setValue({...this.form.value, ...toPatch})
        })
      }),
    )
  }

  pluckFields(rangeType: filterTypeValue) {
    switch (rangeType) {
      case filterTypeValue.BEFORE:
        return ['end']
      case filterTypeValue.AFTER:
        return ['begin']
      case filterTypeValue.BETWEEN_TIMESTAMPS:
        return ['begin', 'end']
      case filterTypeValue.LESS_THAN:
        return ['max']
      case filterTypeValue.GREATER_THAN:
        return ['min']
      case filterTypeValue.BETWEEN_VALUES:
        return ['min', 'max']
      default:
        return []
    }
  }
}
